import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Card, Divider, List, Popconfirm, Typography } from 'antd'
import StackCompletionBar from './StackCompletionBar'
import ShowFilter from './ShowFilter'
import styles from '../../../testrun.module.css'

const formatDate = (d) =>
    new Date(d).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    })

const TestRunItem = (props) => {
    const { item, onDelete, onEdit, percents } = props

    return (
        <List.Item className={styles.listItem}>
            <Card className={styles.reportCard} bordered>
                <div className={styles.reportCardInner}>
                    <div className={styles.reportCardMain}>
                        <div className={styles.reportCardContent}>
                            <Typography.Text
                                ellipsis={{ tooltip: item?.name }}
                                className={styles.reportCardName}
                            >
                                {item?.name}
                            </Typography.Text>

                            <div className={styles.reportCardMeta}>
                                <span>
                                    By {item?.createdBy?.name || 'Unknown'} on{' '}
                                    {formatDate(item?.createdAt)}
                                </span>
                                <Divider
                                    type="vertical"
                                    className={styles.reportCardMetaDivider}
                                />
                                <Typography.Link
                                    className={styles.editLink}
                                    onClick={() => onEdit(item?._id)}
                                >
                                    <EditOutlined style={{ marginRight: 4 }} />
                                    Edit
                                </Typography.Link>
                            </div>

                            <span className={styles.reportCardStats}>
                                {item?.passed} Passed · {item?.pending} Pending
                                · {item?.retest} Retest · {item?.failed} Failed
                            </span>

                            <span className={styles.reportCardFilters}>
                                Group by:{' '}
                                <ShowFilter data={item?.filters || {}} />
                            </span>
                        </div>
                    </div>

                    <div className={styles.reportCardSide}>
                        <div className={styles.progressWrap}>
                            <div className={styles.progressBar}>
                                <StackCompletionBar
                                    percents={percents}
                                    height={14}
                                />
                            </div>
                            <span className={styles.progressPct}>
                                {Math.round(percents.completed)}%
                            </span>
                        </div>

                        <Popconfirm
                            title="Delete this test report?"
                            okText="Delete"
                            okButtonProps={{ danger: true }}
                            onConfirm={() => onDelete(item?._id)}
                        >
                            <Button
                                type="text"
                                className={styles.deleteBtn}
                                icon={<DeleteOutlined />}
                            />
                        </Popconfirm>
                    </div>
                </div>
            </Card>
        </List.Item>
    )
}

export default TestRunItem
